import type { UlmClass } from '../types/content'

export const ulmClasses: UlmClass[] = [
  {
    id: 'multiaxe',
    number: 3,
    name: 'Multiaxe',
    tagline: 'La classe la plus pratiquée en France',
    description:
      "Un avion léger piloté aux trois axes, avec manche et palonnier. Deux places, une cabine fermée, 700 km d'autonomie : c'est le choix de la majorité des pilotes pour voyager.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/745b2e7e-2230-4ddf-9ccf-10ecd2199c1d.jpg',
    featured: true,
  },
  {
    id: 'paramoteur',
    number: 1,
    name: 'Paramoteur',
    tagline: 'Décoller à pied',
    description:
      "Une aile souple, un moteur dans le dos, quelques pas d'élan. Le plus accessible et le plus économique des six classes.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/45fa11a1-53cf-4e3c-a107-aaefecc9014a.jpg',
  },
  {
    id: 'pendulaire',
    number: 2,
    name: 'Pendulaire',
    tagline: 'Le vol à ciel ouvert',
    description:
      "Une aile delta et un chariot moteur, pilotés par déplacement du centre de gravité. Sensations de vol libre, avec la sécurité d'un moteur.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b4ba0024-23fe-429a-b997-4ca70101e2fd.jpg',
  },
  {
    id: 'autogire',
    number: 4,
    name: 'Autogire',
    tagline: 'Rotor libre, vol lent',
    description:
      "Un rotor entraîné par le vent relatif : l'autogire vole lentement, décolle court et reste stable par vent fort.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/800d0bb2-cb13-4ed0-bb2d-1cff206d7cd4.jpg',
  },
  {
    id: 'aerostat',
    number: 5,
    name: 'Aérostat ultraléger',
    tagline: 'Plus léger que l’air',
    description:
      'Ballons et dirigeables ultralégers : la classe la plus contemplative, au rythme du vent et des heures calmes.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0671762f-6387-4837-9d30-4e1bacc045a2.jpg',
  },
  {
    id: 'helicoptere',
    number: 6,
    name: 'Hélicoptère ultraléger',
    tagline: 'Le vol stationnaire',
    description:
      'La classe la plus récente : deux places, rotor motorisé, décollage vertical depuis une surface réduite.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b413a305-9007-4137-b360-c85d866dc3f5.jpg',
  },
]
